import React from 'react';
import { Table, Modal, Button, ModalBody, ModalFooter, ModalHeader } from 'react-bootstrap';
import ReactPlayer from "react-player";
import HlsPlayer from "./HlsPlayer";
import cameraImgLg from "../../../common/images/cameraImgLg.jpg";

const canLoadInIframe = (url) => {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return ["http:", "https:"].includes(parsed.protocol);
  } catch {
    return false;
  }
};

const canLoadRTSP = (url) => {
  if (!url) return false;

  try {
    const parsed = new URL(url);
    return parsed.protocol === "rtsp:";
  } catch {
    return false;
  }
};

export const CameraModalPopup = ({ show, onHide, resultdata }) => {

  const loadWebcamFun = (camera) => {
         
         if(canLoadRTSP(camera?.streamingUrl) && canLoadInIframe(camera?.convertedStreamingUrl)) {
            return (<HlsPlayer streamingurl={camera.convertedStreamingUrl} />);
         } else if(canLoadInIframe(camera?.streamingUrl)) {
              return (<iframe
              src={camera?.streamingUrl}
              title={camera?.name}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />);
         } else {
            return (<div className="unsupported-stream">
                    Unsupported Stream Type
                  </div>);
         }
  }

  return (
    <Modal role="dialog" className='camera-basicdetail-popup' size='xl' show={show} centered={true}>
      <div className="modal-content">
        <button type="button" onClick={onHide} className="btn-close position-absolute end-0 top-0 m-3"></button>
        <ModalHeader>Camera Details</ModalHeader>
        <ModalBody>
          <div className="camera-basicdetail-body">
              <div className="camera-basicdetail-row">
                    <div className='modalview-info-maindiv'>
                      <div className='modalview-info-flx-row'>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Camera Name</div>
                                  <div className='modalview-info-val'>
                                    {resultdata.name} {' '}
                                    {resultdata.category === 'in' && (
                                    <span className="camera-in-cls">IN Camera</span>
                                    )}
                                    {resultdata.category === 'out' && (
                                    <span className="camera-out-cls">OUT Camera</span>
                                    )}
                                    </div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Model</div>
                                  <div className='modalview-info-val'>{resultdata.model}</div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Manufacturer</div>
                                  <div className='modalview-info-val'>{resultdata.manufacturer}</div>
                            </div>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Status</div>
                                  <div className='modalview-info-val'>{(resultdata.isActive==true) ? <span className='status-active-cls'>ACTIVE</span> : <span className='status-inactive-cls'>INACTIVE</span>}</div>
                            </div>
                      </div>
                      <div className='modalview-info-flx-row mt-3'>
                            <div className='modalview-info-col'>
                                  <div className='modalview-info-lable'>Stream URL / RTSP</div>
                                  <div className='modalview-info-val link-txt-cls'>{resultdata.streamingUrl}</div>
                            </div>
                      </div>
                    </div>
              </div>

              <div className="camera-streaming-maindiv">
                    <div className="camera-streaming-inner">
                          <div className="camera-iframe-wrapper">
                              {loadWebcamFun(resultdata)}
                        </div>
                    </div>
              </div>
          </div>
        </ModalBody>
       
      </div>
    </Modal>
  );
};

